// Google Identity Services (GIS) API for authentication
// docs: https://developers.google.com/identity/gsi/web/reference/js-reference
import config from '../../config';
import appendScript from '../dom/appendScript';
import isServer from '../isServer';

const api = config.oauth.google.api;

let isGisLoaded = false;

function _appendGisScript(onLoad) {
  if (!window.google?.accounts?.id) {
    appendScript(api, onLoad);
  } else {
    onLoad();
  }
}

export function setupGoogleIdentityServices(onLoad, hasErrored) {
  if (isServer()) {
    return;
  }

  if (isGisLoaded && !hasErrored) {
    onLoad();
    return;
  }

  _appendGisScript(() => {
    isGisLoaded = true;
    onLoad();
  });
}

export function renderGoogleSignInButton(container, options = {}) {
  if (isServer() || !window.google?.accounts?.id) {
    return;
  }

  const defaultOptions = {
    type: 'standard',
    theme: 'outline',
    size: 'large',
    shape: 'pill',
    text: 'continue_with',
    logo_alignment: 'center',
    width: '320px',
  };

  const buttonOptions = { ...defaultOptions, ...options };

  try {
    window.google.accounts.id.renderButton(container, buttonOptions);
  } catch (error) {
    console.error('Error rendering Google Sign-In button:', error);
  }
}
